export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.5c1544d6.worker.js");
}
